const RootAppLayout = ({ children }) => {
  return (
    <div
      className={`w-full min-h-screen bg-primary-500 bg-gradient-to-br from-primary-500 to-primary-200 flex flex-col justify-center items-center gap-10`}
    >
      {children}
    </div>
  );
};

export default RootAppLayout;
